import { useState, useEffect, useRef, useCallback } from "react";
import createPersistedState from "use-persisted-state";
import { useRouter } from "next/router";

const Toggle = () => {
  const router = useRouter();
  const divToView = useRef(null);

  const links = [
    "Arts",
    "Entertainment",
    "Gospel",
    "Music",
    "News",
    "Politics",
    "Sport",
    "Talk",
    "Top 40",
    "Variety",
    "Akan",
    "English",
    "Hausa",
    "Multilingual",
    "Accra",
    "Bogoso",
    "Cape Coast",
    "Donkorkrom",
    "Ho",
    "Kasoa",
    "Koforidua",
    "Kumasi",
    "Nkrofro",
    "Somanya",
    "Sunyani",
    "Swedru",
    "Takoradi",
    "Tamale",
    "Tarkwa",
    "Tema",
    "USA",
    "Unknown",
  ];

  const useCartState = createPersistedState("isopen");
  const [isopen, setIsopen] = useCartState(false);
  const useQueryState = createPersistedState("query");
  const [query, setQuery] = useQueryState("undefined");
  const useQueryStateCurMenuItm = createPersistedState("curMenuItem");
  const [curMenuItem, setCurMenuItem] = useQueryStateCurMenuItm("location");
  const useQueryStateBolean = createPersistedState("queryState");
  const [queryState, setQueryState] = useQueryStateBolean(false);
  const useRecentStation = createPersistedState("recentStation");
  const [recentStation, setRecentStation] = useRecentStation([]);
  //const [isopen, setIsopen] = useState(false);

  const [isActive, setIsActive] = useState("");
  const [toView, setToView] = useState("");

  //========= Active nav style function ========
  const activeLink = (val) => {
    if (links.includes(val)) {
      setIsActive(val);
    }
  };

  //========= function to change selected options ========
  const inputText = (input) => {
    setQuery(input);
  };

  //========= Get recentStation from localSStorage ========
  const addToRecentStions = (singleView) => {
    if (!recentStation.some((recent) => recent.id === singleView.id)) {
      setRecentStation([...recentStation, singleView]);
    }
  };

  //====== Function to clear recenStation from localStorage =========
  const clearStorage = () => {
    if (recentStation) {
      setRecentStation([]);
    }
  };

  const handleToggle = () => {
    setIsopen(!isopen);
  };

  const closeSideBar = () => {
    setIsopen(false);
  };

  useEffect(() => {
    setIsopen(false);
    setQuery("undefined");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //================ Move stream-wrapper to top view =======================
  // const divToView = useCallback((node) => {
  //   if (node !== null) {
  //     setToView(node);
  //   }
  // }, []);

  const moveToTop = () => {
    // if (router.pathname === "/") {
    //   setTimeout(function () {
    //     if (divToView && divToView.current !== null) {
    //       toView.scrollIntoView({
    //         behavior: "smooth",
    //         block: "start",
    //       });
    //     }
    //   }, 100);
    // }
    // toView.scrollIntoView({
    //   behavior: "smooth",
    //   block: "end",
    //   inline: "nearest",
    // });
    // if (divToView.current !== null) {
    //   divToView.current.scrollIntoView({
    //     behavior: "smooth",
    //     block: "end",
    //     inline: "nearest",
    //   });
    // }
    // console.log("am clicked");
    // if (divToView && divToView.current !== null) {
    //   divToView.current.scrollIntoView({
    //     behavior: "smooth",
    //     block: "start",
    //   });
    // }
  };

  // useEffect(() => {
  //   if (queryState === true && divToView) {
  //     divToView.current.scrollIntoView({ behavior: "smooth", block: "start" });
  //   }
  // }, [divToView, queryState]);

  return {
    query,
    isopen,
    isActive,
    queryState,
    curMenuItem,
    recentStation,
    divToView,
    setQuery,
    setIsopen,
    setQueryState,
    setCurMenuItem,
    setRecentStation,
    inputText,
    activeLink,
    handleToggle,
    closeSideBar,
    clearStorage,
    addToRecentStions,
    moveToTop,
  };
};

export default Toggle;
